import type { UserInfoType } from "#src/api/user/types";

import { create } from "zustand";

const initialState: UserInfoType = {
	id: "",
	avatar: "",
	name: "",
	username: "",
	email: "",
	phoneNumber: "",
	description: "",
	roles: [],
	// menus: [],
};

type UserState = UserInfoType;

interface UserAction {
	getUserInfo: () => Promise<UserInfoType>
	setUserInfo: (userInfo: Partial<UserInfoType>) => void
	reset: () => void
};

export const useUserStore = create<UserState & UserAction>()(
	(set, get) => ({
		...initialState,

		// Modified to check if user info already exists in store
		getUserInfo: async (): Promise<UserInfoType> => {
			// Get current state using get() function instead of store.getState()
			const currentState = get();

			// Check if we already have user info (at least id is set)
			if (currentState.id) {
				// Return existing user info without fetching
				return {
					id: currentState.id,
					avatar: currentState.avatar,
					name: currentState.name,
					username: currentState.username,
					email: currentState.email,
					phoneNumber: currentState.phoneNumber,
					description: currentState.description,
					roles: currentState.roles,
				};
			}

			// If no user info exists, fetch from API
			// const response = await fetchUserInfo();
			const response = {
				id: '1',
				avatar: '',
				name: 'fake',
				username: 'false username',
				email: 'fake email',
				phoneNumber: '000',
				description: 'false description',
				roles: [],
			};
			// Extract data from ApiResponse
			const userInfo = response;

			set({
				...userInfo,
			});

			return userInfo;
		},

		// New function to set user info directly
		setUserInfo: (userInfo: Partial<UserInfoType>): void => {
			set(state => ({
				...state,
				...userInfo,
			}));
		},

		reset: (): void => {
			set({
				...initialState,
			});
		},
	}),
);
